module.exports = __webpack_public_path__ + "img/error-page-bg@mb.a8b0130.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/error-page-bg@mb.svg
// module id = ohMf
// module chunks = 13